import { createContext, useState } from "react";

export const AccountAagregatorContext = createContext();

const AccountAagregatorProvider = ({ children }) => {
  const [collectedAccountAggregatorData, setollectedAccountAggregatorData] =
    useState({});
  const collectAccountAggregatorData = (data) => {
    setollectedAccountAggregatorData((prevData) => ({ ...prevData, ...data }));
  };

  return (
    <AccountAagregatorContext.Provider
      value={{
        collectedAccountAggregatorData,
        collectAccountAggregatorData,
      }}
    >
      {children}
    </AccountAagregatorContext.Provider>
  );
};
export default AccountAagregatorProvider;
